import { useEffect } from 'react'
import StoreView from '../components/StoreView'
import { getAppSubdomain } from '../utils/domain-utils'
import styles from './Main.module.css'

export default function Main() {
  useEffect(() => {
    // To debug on different environments
    console.log('app domain', getAppSubdomain())
  }, [])

  return (
    <div className={styles.root}>
      <StoreView></StoreView>
    </div>
  )
}
